import axios from './../http/axiosInstance';
import { USER_STATUS } from '../types/auth';
import { APP_PREFIX } from '../constants/auth';
function API(storeData = {
    baseUrl: '',
}) {
    const excludeSubscriptionUserBlockedPath = ['/auth'];
    const isSilent = () => localStorage.getItem('mode') === 'silent';
    const urlString = (params) => {
        if (!params) {
            return '';
        }
        return Object.entries(params)
            .map(([name, value]) => {
            const encodedValue = encodeURIComponent(String(value));
            return name === 'email'
                ? `${encodeURIComponent(name)}=${encodedValue.replace(/%40/g, '@')}`
                : `${encodeURIComponent(name)}=${encodedValue}`;
        })
            .join('&');
    };
    const makeUrl = (uri = '', options = {}) => {
        const queryString = urlString(options);
        return isSilent()
            ? `${storeData?.baseUrl}/${uri}?silent=true&${queryString}`
            : `${storeData?.baseUrl}/${uri}?${queryString}`;
    };
    const createRequestConfig = ({ method = 'GET', url = '', data = {}, credentials = 'same-origin', headers = {}, }) => {
        return {
            method,
            url,
            data: JSON.stringify(data),
            headers: {
                Cache: 'no-cache',
                ...(storeData?.headers?.authorization
                    ? { Authorization: storeData?.headers?.authorization }
                    : {}),
                ...headers,
            },
            withCredentials: credentials === 'same-origin',
        };
    };
    const handleRequest = async (config) => {
        try {
            return await axios(createRequestConfig(config));
        }
        catch (error) {
            console.error(`${config.method} ERROR RESPONSE`);
            return error;
        }
    };
    const GET = (url = '', directUrl = false, urlParams = {}, headers = {}) => {
        if (storeData.userStatus === USER_STATUS.BLOCKED) {
            const isExclude = excludeSubscriptionUserBlockedPath.some((matchUrl) => !!(url.match(matchUrl) || []).length);
            if (!isExclude) {
                return Promise.resolve({});
            }
        }
        return handleRequest({
            method: 'GET',
            url: directUrl ? url : makeUrl(url, urlParams),
            headers,
        });
    };
    const POST = (url = '', data = {}, directUrl = false, urlParams = {}, credentials = 'same-origin', headers = {}) => handleRequest({
        method: 'POST',
        url: directUrl ? url : makeUrl(url, urlParams),
        data,
        credentials,
        headers,
    });
    const DELETE = (url = '', urlParams = {}, headers = {}) => handleRequest({
        method: 'DELETE',
        url: makeUrl(url, urlParams),
        headers,
    });
    const AUTH = {
        login: (urlParams = {}) => {
            let loginPath = '';
            switch (storeData.appPrefix) {
                case APP_PREFIX.ADMIN:
                    loginPath = 'auth/login/admin';
                    break;
                case APP_PREFIX.PUB:
                    loginPath = 'auth';
                    break;
                default:
                    loginPath = 'auth/login/v2';
            }
            return POST(loginPath, urlParams, false);
        },
        refreshToken: (urlParams = {}, headers = {}) => {
            let refreshPath = '';
            switch (storeData.appPrefix) {
                case APP_PREFIX.PUB:
                    refreshPath = 'refresh';
                    break;
                default:
                    refreshPath = 'auth/refresh';
            }
            if (storeData.appPrefix === APP_PREFIX.PUB) {
                return POST(refreshPath, {}, false, {}, 'same-origin', headers);
            }
            return GET(refreshPath, false, urlParams, headers);
        },
        logOut: (urlParams = {}, headers = {}) => {
            let logOutPath = '';
            switch (storeData.appPrefix) {
                case APP_PREFIX.PUB:
                    logOutPath = 'sessions';
                    break;
                default:
                    logOutPath = 'auth/sessions';
            }
            return DELETE(logOutPath, urlParams, headers);
        },
        loginShared: (id) => GET(`auth/shared/${id}/login`),
    };
    const USER = {
        load: (headers = {}) => GET('auth', false, {}, headers),
        loadByApiKey: (apiKey) => GET('me', false, { api_key: apiKey }),
    };
    return {
        AUTH,
        USER,
    };
}
export default API;
//# sourceMappingURL=api.js.map